export interface DiabguideRecommendationArgs {
  cardioRisk: { label: string; note: string };
  glycemicObjectives: {
    hba: string;
    subtitle: string;
    note: string;
  };
  lipidObjectives: {
    ldl: string;
    note: string;
  };
  bloodPressureObjectives: {
    systolic: {
      label: string;
    };
    diastolic: {
      label: string;
    };
    note: string;
  };
  therapeuticStrategy: {
    label: string;
    info: string;
    children: { label: string; choice: string }[];
  }[];
}

export default class DiabguideRecommendation {
  "bloodPressureObjectives": {
    systolic: {
      label: string;
    };
    diastolic: {
      label: string;
    };
    note: string;
  };
  "cardioRisk": { label: string; note: string };
  "glycemicObjectives": {
    hba: string;
    subtitle: string;
    note: string;
  };
  "lipidObjectives": {
    ldl: string;
    note: string;
  };
  "therapeuticStrategy": {
    label: string;
    info: string;
    children: { label: string; choice: string }[];
  }[];

  constructor(diabguideRecommendation: DiabguideRecommendationArgs) {
    const {
      cardioRisk,
      glycemicObjectives,
      lipidObjectives,
      bloodPressureObjectives,
      therapeuticStrategy
    } = diabguideRecommendation;
    this.cardioRisk = cardioRisk;
    this.glycemicObjectives = glycemicObjectives;
    this.lipidObjectives = lipidObjectives;
    this.bloodPressureObjectives = bloodPressureObjectives;
    this.therapeuticStrategy = therapeuticStrategy;
  }

  serialize(): DiabguideRecommendationArgs {
    return {
      cardioRisk: this.cardioRisk,
      glycemicObjectives: this.glycemicObjectives,
      lipidObjectives: this.lipidObjectives,
      bloodPressureObjectives: this.bloodPressureObjectives,
      therapeuticStrategy: this.therapeuticStrategy
    };
  }
}
